import { useTranslation } from 'react-i18next';

const OtrosBarcos = ({ relacionados, ruta, lang }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";


    return (
        <>
            {
                (relacionados.length > 0)
                    ?
                    <>
                        <section className="skrollable u-align-center u-clearfix u-container-align-center u-image u-parallax u-section-8" id="block-14" data-image-width="1920" data-image-height="1080">
                            <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xs u-sheet-1">
                                <h1 className="u-align-center u-text u-text-white u-text-1">{t("Descubre barcos similares")}</h1>
                            </div>
                        </section>
                        <section className="u-align-center u-clearfix u-container-align-center u-container-align-center-lg u-container-align-center-xl u-section-9" id="sec-d527">
                            <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-sheet-1">
                                <div className="u-expanded-width u-layout-horizontal u-list u-list-1">
                                    <div className="u-repeater u-repeater-1">

                                        {relacionados.map((unbarco, index) => (
                                            <>
                                                <div className="u-align-center u-container-align-center u-container-style u-list-item u-repeater-item" key={"rel-" + index}>
                                                    <div className={"u-container-layout u-similar-container u-container-layout-" + (index + 1)}>
                                                        {
                                                            (unbarco.foto_principal && unbarco.foto_principal.length > 0) ?
                                                                <img className="mb-3 u-expanded-width u-image u-image-round u-radius u-image-1" alt="" data-image-width="3753" data-image-height="2534" src={ruta + "/propiedades/" + unbarco.id + "/fotos/web/" + unbarco.foto_principal[0].nombre} />
                                                                :
                                                                <img className="mb-3 u-expanded-width u-image u-image-round u-radius u-image-1" alt="" data-image-width="2062" data-image-height="1374" src="/images/web/onboard2/00-ONBOARDLOGO-HORIZONTAL-TR_TRANSP-2025.png" />
                                                        }
                                                        <i className="fa-solid fa-ruler-triangle"></i> {unbarco['metros_cuadrados']}m | <i className="fa-solid fa-bed"></i> {unbarco['num_habitaciones']} | <i className="fa-solid fa-users"></i> {unbarco.capacidad_maxima}
                                                        <h4 className="u-text u-text-1">
                                                            <a href={"/" + preidioma + t("embarcaciones") + "-" + unbarco.destino.url_dinamica[lang] + "/" + unbarco.url_dinamica} className="u-active-none u-border-none u-btn u-button-style u-hover-none u-none u-text-palette-1-base u-btn-5">{unbarco.nombre}
                                                            </a>
                                                        </h4>
                                                        <p className="u-align-center u-text u-text-grey-50 u-text-2">{unbarco.nombre_ruta}
                                                        </p>
                                                        <a href={"mailto:info@onboardholidays.com?subject=Quiero%20solicitar%20disponibilidad%20para%20" + unbarco.nombre} className="u-align-center u-btn u-btn-round u-button-style u-hover-palette-1-light-1 u-palette-1-base u-radius u-btn-2">{t("Solicitar")} </a>
                                                    </div>
                                                </div>
                                            </>
                                        ))
                                        }
                                    </div>
                                </div>
                                <a className="u-absolute-vcenter u-gallery-nav u-gallery-nav-prev u-grey-70 u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-white u-gallery-nav-1" href="#" role="button">
                                    <span aria-hidden="true">
                                        <svg viewBox="0 0 451.847 451.847">
                                            <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
            c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
            c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path>
                                        </svg>
                                    </span>
                                    <span className="sr-only">
                                        <svg viewBox="0 0 451.847 451.847">
                                            <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
                                c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
                                c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"></path>
                                        </svg>
                                    </span>
                                </a>
                                <a className="u-absolute-vcenter u-gallery-nav u-gallery-nav-next u-grey-70 u-icon-circle u-opacity u-opacity-70 u-spacing-10 u-text-white u-gallery-nav-2" href="#" role="button">
                                    <span aria-hidden="true">
                                        <svg viewBox="0 0 451.846 451.847">
                                            <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
                                L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
                                c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path>
                                        </svg>
                                    </span>
                                    <span className="sr-only">
                                        <svg viewBox="0 0 451.846 451.847">
                                            <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
                                L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
            c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"></path>
                                        </svg>
                                    </span>
                                </a>
                            </div>
                        </section >
                        <section className="u-clearfix u-section-10" id="block-11">
                            <div className="u-clearfix u-sheet u-sheet-1"></div>
                        </section>
                    </>
                    :
                    ""
            }
        </>
    )
}
export default OtrosBarcos;
